module.exports = __webpack_public_path__ + "img/logo.990c5cdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1